type Translate = (key: string, options?: Record<string, unknown>) => string;

export function appliedRateName(
  rate: { source: 'tier' | 'special' | 'event'; name: string },
  t: Translate,
): string {
  return rate.source === 'tier' ? t('simulator.standardTier') : rate.name;
}
